import { MenuItem } from "@/components/ui/menu";
import { Post } from "@/lib/types";
import { urlToAtUri } from "@/lib/utils";

export function PdsLsMenuItem({ post }: { post: Post }) {
  return (
    <MenuItem
      onSelect={() => {
        window.open(`https://pdsls.dev/${urlToAtUri(post.uri)}`, "_blank");
      }}
    >
      Open in pdsls.dev
    </MenuItem>
  );
}
